import React, { useEffect, useRef, useState } from 'react';
import { playTone } from './posFeedback';
import './Pos.css';

const DeskStation = ({
  title,
  hint,
  options,
  selected,
  onSelect,
  extra,
  onScan,
}) => {
  const inputRef = useRef(null);
  const timerRef = useRef(null);
  const [query, setQuery] = useState('');
  const [overlay, setOverlay] = useState(null);

  useEffect(() => {
    inputRef.current?.focus();
    return () => clearTimeout(timerRef.current);
  }, []);

  const focusScan = () => inputRef.current?.focus();

  const onBlur = (event) => {
    const next = event.relatedTarget;
    if (!next) {
      setTimeout(focusScan, 0);
      return;
    }
    const tag = next.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'BUTTON' || tag === 'A') {
      return;
    }
    setTimeout(focusScan, 0);
  };

  const showResult = (result) => {
    setOverlay(result);
    playTone(result.color === 'green' ? 'ok' : 'bad');
    const wait = result.color === 'green' ? 1200 : 2000;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setOverlay(null);
      focusScan();
    }, wait);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const value = query.trim();
    if (!value || !selected) return;
    setQuery('');
    try {
      showResult(await onScan(value));
    } catch (err) {
      showResult({
        color: 'red',
        message: err.response?.data?.error || '操作失敗',
        code: 'error',
      });
    }
    focusScan();
  };

  return (
    <div className="pos-station">
      <h1>{title}</h1>
      <p className="pos-hint">{hint}</p>
      <select
        className="pos-station-select"
        value={selected}
        onChange={(event) => onSelect(event.target.value)}
      >
        <option value="">請選擇</option>
        {options}
      </select>
      {extra}
      <form onSubmit={onSubmit}>
        <input
          ref={inputRef}
          className="pos-scan-input"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onBlur={onBlur}
          placeholder="掃描會員證"
          aria-label="櫃台掃描"
          autoComplete="off"
          autoFocus
        />
      </form>
      {overlay && (
        <div className={`pos-overlay ${overlay.color}`} role="status">
          <div>
            <h2>{overlay.message}</h2>
            {overlay.member && (
              <>
                <p>{overlay.member.chinese_name}</p>
                <p>{overlay.member.member_number}</p>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DeskStation;
